import {Redirect, Route, useHistory, useLocation} from 'react-router-dom';
// eslint-disable-next-line no-unused-vars
import React, {Component, useEffect, useState} from "react";
import { decodeToken, getAccessToken } from "./authUtil";
import url from "./routeURL";
import ApiService from "../ApiService";
import useUserStore from "../hook/useUserStore";
import CircularProgress from "@material-ui/core/CircularProgress";
import CustomRedirect from "../components/common/CustomRedirect";
import { getMainSitePatientPortalSignInUrl } from '../config/mainSiteUrls';
import {
  IS_SANDBOX_ENV,
  SANDBOX_ALLOWED_EMAIL_SUFFIXES,
} from '../config/sandboxPatientAccessConfig';
import { isSandboxAllowedPatientEmail } from './isSandboxAllowedPatientEmail';

const AuthRoute = ({ component: Component, path, exact, ...rest }) => {
    const [loading, setLoading] = useState(true);
    const patient = useUserStore((state) => state.patient);
    const setPatient = useUserStore((state) => state.setPatient);
    const isAuth = useUserStore((state) => state.isAuth);
    const setIsAuth = useUserStore((state) => state.setIsAuth);
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        setLoading(true);
        const checkUserSignedIn = async () => {
            try {
                const accessToken = await getAccessToken();
                const decoded = decodeToken(accessToken);

                if (!accessToken || !decoded) {
                    setIsAuth(false);
                    setPatient(null);
                    return;
                }

                if (isAuth !== true) setIsAuth(true);
                try {
                    const res = await ApiService.getPatientAfterSessRef();
                    setPatient(res.data);
                } catch (patientErr) {
                    // A transient data-load failure (network/5xx) must not de-auth
                    // the user. Definitive auth failures (missing token / 401) are
                    // handled by the API auth-failure interceptor, which drives the
                    // centralized logout flow.
                    console.error(patientErr);
                }
            } catch (err) {
                setIsAuth(false);
                setPatient(null);
            } finally {
                setLoading(false);
            }
        };
        checkUserSignedIn();
    }, [path, Component]);

    const shouldRedirectSandboxUserToMainSiteSignIn = () => {
        if (!isAuth || !IS_SANDBOX_ENV) {
            return false;
        }
        return !isSandboxAllowedPatientEmail(patient?.email, SANDBOX_ALLOWED_EMAIL_SUFFIXES);
    };

    const renderFunc = (props, rest) => {
        if (loading){
            return <CircularProgress className="loading-button-spinner"/>;
        }
        if (shouldRedirectSandboxUserToMainSiteSignIn()) {
            return <CustomRedirect redirectUrl={getMainSitePatientPortalSignInUrl()} />;
        }
        if (!isAuth){
            const redirectTo = window.location.pathname + window.location.search;
            const loginUrl = `${url.login}?next=${redirectTo}`;
            return <Redirect to={loginUrl} {...rest} />;
        }
        //send actual component,
        // else it will create circular redirect. i.e: AuthRoute -> healthProfile Redirect -> AuthRoute
        if(path === url.healthProfile){
            return <Component {...props} {...rest} />;
        }
        return <Component {...props} {...rest} />;
    };
    return (
        <Route
            path={path}
            exact={exact}
            render={props => renderFunc(props, rest)} />
    );
}

export default AuthRoute;
